/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "notif/models.proto" (package "rd.notif", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../google/protobuf/timestamp_pb";
import { User } from "../user/models_pb";
import { UUID } from "../proto/uuid/models_pb";
/**
 * Content describes Notif message.
 *
 * @generated from protobuf message rd.notif.Content
 */
export interface Content {
    /**
     * @generated from protobuf field: string subject = 1
     */
    subject: string;
    /**
     * @generated from protobuf field: string body = 2
     */
    body: string;
    /**
     * @generated from protobuf field: string action_url = 3
     */
    actionUrl: string;
    /**
     * ContentBlock used for complex email notifications content.
     * If this isn't set, body string will be used
     *
     * @generated from protobuf field: repeated rd.notif.Content.ContentBlock content_blocks = 4
     */
    contentBlocks: Content_ContentBlock[];
}
/**
 * exactly 1 field of ContentBlock must be populated
 *
 * @generated from protobuf message rd.notif.Content.ContentBlock
 */
export interface Content_ContentBlock {
    /**
     * @generated from protobuf field: string paragraph = 1
     */
    paragraph: string;
    /**
     * @generated from protobuf field: repeated rd.notif.Content.ContentBlock.KeyValue key_values = 2
     */
    keyValues: Content_ContentBlock_KeyValue[];
}
/**
 * @generated from protobuf message rd.notif.Content.ContentBlock.KeyValue
 */
export interface Content_ContentBlock_KeyValue {
    /**
     * @generated from protobuf field: string key = 1
     */
    key: string;
    /**
     * @generated from protobuf field: string value = 2
     */
    value: string;
}
/**
 * Notif represents a notification that a calling package wants to send. It
 * describes what should be sent, to whom, and when. Multiple Notifs may be
 * created for the same event, which can be associated together by the batch_id.
 * A single Notif can generate multiple Deliveries when processed.
 *
 * @generated from protobuf message rd.notif.Notif
 */
export interface Notif {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.notif.Notif.Target target = 2
     */
    target?: Notif_Target;
    /**
     * @generated from protobuf field: rd.notif.Event event = 3
     */
    event: Event;
    /**
     * @generated from protobuf field: rd.user.User sender = 4
     */
    sender?: User;
    /**
     * @generated from protobuf field: rd.notif.Content content = 5
     */
    content?: Content;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp scheduled_at = 6
     */
    scheduledAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID batch_id = 8
     */
    batchId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 9
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 10
     */
    locationId?: UUID;
}
/**
 * Target describes the recipient(s) of the notification.
 *
 * @generated from protobuf message rd.notif.Notif.Target
 */
export interface Notif_Target {
    /**
     * @generated from protobuf field: rd.notif.Notif.Target.Type type = 1
     */
    type: Notif_Target_Type;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 2
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: string customer_contact_id = 3
     */
    customerContactId: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID staff_id = 4
     */
    staffId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID in_app_location_id = 5
     */
    inAppLocationId?: UUID; // Scope in-app deliveries to a location
}
/**
 * Type describes the type of Target and is used to determine the
 * recipients.
 *
 * @generated from protobuf enum rd.notif.Notif.Target.Type
 */
export enum Notif_Target_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * all contacts of the customer
     *
     * @generated from protobuf enum value: TYPE_SINGLE_CUSTOMER = 1;
     */
    SINGLE_CUSTOMER = 1,
    /**
     * @generated from protobuf enum value: TYPE_SINGLE_CUSTOMER_PRIMARY_CONTACT = 2;
     */
    SINGLE_CUSTOMER_PRIMARY_CONTACT = 2,
    /**
     * @generated from protobuf enum value: TYPE_SINGLE_CUSTOMER_CONTACT = 3;
     */
    SINGLE_CUSTOMER_CONTACT = 3,
    /**
     * @generated from protobuf enum value: TYPE_SINGLE_STAFF = 4;
     */
    SINGLE_STAFF = 4,
    /**
     * all relevant staff for event type
     *
     * @generated from protobuf enum value: TYPE_ALL_STAFF = 5;
     */
    ALL_STAFF = 5,
    /**
     * used to create parent Notif for migrating old
     *
     * @generated from protobuf enum value: TYPE_MIGRATED = 6;
     */
    MIGRATED = 6
}
/**
 * Delivery represents a single notification delivery through a specific Sink.
 *
 * @generated from protobuf message rd.notif.Delivery
 */
export interface Delivery {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.notif.Delivery.Recipient recipient = 2
     */
    recipient: Delivery_Recipient;
    /**
     * @generated from protobuf field: rd.notif.Delivery.Email email = 3
     */
    email?: Delivery_Email;
    /**
     * @generated from protobuf field: rd.notif.Delivery.SMS sms = 4
     */
    sms?: Delivery_SMS;
    /**
     * @generated from protobuf field: rd.notif.Delivery.InApp in_app = 5
     */
    inApp?: Delivery_InApp;
    /**
     * @generated from protobuf field: rd.notif.Sink sink = 12
     */
    sink: Sink;
    /**
     * @generated from protobuf field: rd.notif.Content content = 13
     */
    content?: Content;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp notified_at = 14
     */
    notifiedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 15
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp read_at = 16
     */
    readAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp archived_at = 17
     */
    archivedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID notif_id = 18
     */
    notifId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 19
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 20
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: rd.notif.Delivery.Status status = 21
     */
    status: Delivery_Status;
}
/**
 * @generated from protobuf message rd.notif.Delivery.Email
 */
export interface Delivery_Email {
    /**
     * @generated from protobuf field: string from_email = 1
     */
    fromEmail: string;
    /**
     * @generated from protobuf field: string from_name = 2
     */
    fromName: string;
    /**
     * @generated from protobuf field: string reply_to_email = 3
     */
    replyToEmail: string;
    /**
     * @generated from protobuf field: string logo_url = 4
     */
    logoUrl: string;
    /**
     * @generated from protobuf field: string website_url = 5
     */
    websiteUrl: string;
    /**
     * @generated from protobuf field: string to_email = 6
     */
    toEmail: string;
    /**
     * @generated from protobuf field: string to_name = 7
     */
    toName: string;
    /**
     * @generated from protobuf field: bool allow_inactive_company = 8
     */
    allowInactiveCompany: boolean;
}
/**
 * @generated from protobuf message rd.notif.Delivery.SMS
 */
export interface Delivery_SMS {
    /**
     * @generated from protobuf field: string from_phone = 1
     */
    fromPhone: string;
    /**
     * @generated from protobuf field: string to_phone = 2
     */
    toPhone: string;
}
/**
 * @generated from protobuf message rd.notif.Delivery.InApp
 */
export interface Delivery_InApp {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID user_id = 1
     */
    userId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 2
     */
    locationId?: UUID;
}
/**
 * Recipient stores the category of recipient this Notif will be sent to
 * Used in email template to determine which logo to show at the top of the
 * template
 *
 * @generated from protobuf enum rd.notif.Delivery.Recipient
 */
export enum Delivery_Recipient {
    /**
     * @generated from protobuf enum value: RECIPIENT_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: RECIPIENT_STAFF = 1;
     */
    STAFF = 1,
    /**
     * @generated from protobuf enum value: RECIPIENT_CUSTOMER = 2;
     */
    CUSTOMER = 2
}
/**
 * @generated from protobuf enum rd.notif.Delivery.Status
 */
export enum Delivery_Status {
    /**
     * @generated from protobuf enum value: STATUS_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: STATUS_PENDING = 1;
     */
    PENDING = 1,
    /**
     * @generated from protobuf enum value: STATUS_SENDING = 2;
     */
    SENDING = 2,
    /**
     * @generated from protobuf enum value: STATUS_SENT = 3;
     */
    SENT = 3,
    /**
     * @generated from protobuf enum value: STATUS_FAILED = 4;
     */
    FAILED = 4
}
/**
 * Preferences stores the Sinks that the user has opted OUT of receiving
 *
 * @generated from protobuf message rd.notif.Preferences
 */
export interface Preferences {
    /**
     * @generated from protobuf field: repeated rd.notif.Sink disabled_sinks = 1
     */
    disabledSinks: Sink[];
}
/**
 * PreferenceUpdate stores the change to make for a specific (event, sink)
 * checkbox
 *
 * @generated from protobuf message rd.notif.PreferenceUpdate
 */
export interface PreferenceUpdate {
    /**
     * @generated from protobuf field: rd.notif.Event event = 1
     */
    event: Event;
    /**
     * @generated from protobuf field: rd.notif.Sink sink = 2
     */
    sink: Sink;
    /**
     * @generated from protobuf field: bool enabled = 3
     */
    enabled: boolean;
}
/**
 * StaffPreferences stores notification delivery preferences per
 * event for staff members.
 *
 * @generated from protobuf message rd.notif.StaffPreferences
 */
export interface StaffPreferences {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // staff id
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * keys are of type Event
     *
     * @generated from protobuf field: map<int32, rd.notif.Preferences> preferences = 5
     */
    preferences: {
        [key: number]: Preferences;
    };
}
/**
 * CustomerContactPreferences stores notification delivery
 * preferences per event for customer contacts
 *
 * @generated from protobuf message rd.notif.CustomerContactPreferences
 */
export interface CustomerContactPreferences {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string; // customer contact id
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 4
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 5
     */
    companyId?: UUID;
    /**
     * keys are of type Event
     *
     * @generated from protobuf field: map<int32, rd.notif.Preferences> preferences = 6
     */
    preferences: {
        [key: number]: Preferences;
    };
}
/**
 * Sink defines the delivery mechanism for a Notif.
 *
 * @generated from protobuf enum rd.notif.Sink
 */
export enum Sink {
    /**
     * @generated from protobuf enum value: SINK_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: SINK_IN_APP = 1;
     */
    IN_APP = 1,
    /**
     * @generated from protobuf enum value: SINK_EMAIL = 2;
     */
    EMAIL = 2,
    /**
     * @generated from protobuf enum value: SINK_SMS = 3;
     */
    SMS = 3
}
/**
 * Event defines the type of Notif being sent and is used to determine
 * applicable Sinks.
 *
 * @generated from protobuf enum rd.notif.Event
 */
export enum Event {
    /**
     * @generated from protobuf enum value: EVENT_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: EVENT_BILL_PAYMENT = 1;
     */
    BILL_PAYMENT = 1,
    /**
     * @generated from protobuf enum value: EVENT_ORDER_ACKNOWLEDGMENT = 2;
     */
    ORDER_ACKNOWLEDGMENT = 2,
    /**
     * @generated from protobuf enum value: EVENT_SHIPMENT_NOTIFICATION = 3;
     */
    SHIPMENT_NOTIFICATION = 3,
    /**
     * @generated from protobuf enum value: EVENT_DAILY_SUMMARY = 4;
     */
    DAILY_SUMMARY = 4,
    /**
     * @generated from protobuf enum value: EVENT_LINK_BANK_ACCOUNT_REQUEST = 5;
     */
    LINK_BANK_ACCOUNT_REQUEST = 5,
    /**
     * @generated from protobuf enum value: EVENT_ACH_PAYMENT_SUCCESS = 6;
     */
    ACH_PAYMENT_SUCCESS = 6,
    /**
     * @generated from protobuf enum value: EVENT_ACH_PAYMENT_FAILURE = 7;
     */
    ACH_PAYMENT_FAILURE = 7,
    /**
     * @generated from protobuf enum value: EVENT_AUTOPAY_FAILURE = 8;
     */
    AUTOPAY_FAILURE = 8,
    /**
     * @generated from protobuf enum value: EVENT_TRANSFER_REQUEST = 9;
     */
    TRANSFER_REQUEST = 9,
    /**
     * @generated from protobuf enum value: EVENT_DISPUTE = 10;
     */
    DISPUTE = 10,
    /**
     * @generated from protobuf enum value: EVENT_ROUTINE_RUN = 11;
     */
    ROUTINE_RUN = 11,
    /**
     * @generated from protobuf enum value: EVENT_INVALID_DOMAIN = 12;
     */
    INVALID_DOMAIN = 12,
    /**
     * @generated from protobuf enum value: EVENT_PRICE_CHANGE = 13;
     */
    PRICE_CHANGE = 13,
    /**
     * @generated from protobuf enum value: EVENT_LLM_NOTIFICATION = 14;
     */
    LLM_NOTIFICATION = 14,
    /**
     * @generated from protobuf enum value: EVENT_ECOMM_ORDER_PLACED = 15;
     */
    ECOMM_ORDER_PLACED = 15,
    /**
     * @generated from protobuf enum value: EVENT_ECOMM_ORDER_CANCELLED = 16;
     */
    ECOMM_ORDER_CANCELLED = 16,
    /**
     * @generated from protobuf enum value: EVENT_ECOMM_ORDER_PICKED_UP = 17;
     */
    ECOMM_ORDER_PICKED_UP = 17,
    /**
     * @generated from protobuf enum value: EVENT_SALE_WILL_CALLED = 18;
     */
    SALE_WILL_CALLED = 18,
    /**
     * @generated from protobuf enum value: EVENT_OVERDUE_BALANCE = 19;
     */
    OVERDUE_BALANCE = 19,
    /**
     * @generated from protobuf enum value: EVENT_STOP_STATUS_UPDATE = 20;
     */
    STOP_STATUS_UPDATE = 20,
    /**
     * @generated from protobuf enum value: EVENT_AGREEMENT_SIGNER_LOGIN_DETAILS = 21;
     */
    AGREEMENT_SIGNER_LOGIN_DETAILS = 21
}
// @generated message type with reflection information, may provide speed optimized methods
class Content$Type extends MessageType<Content> {
    constructor() {
        super("rd.notif.Content", [
            { no: 1, name: "subject", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "body", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "action_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "content_blocks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Content_ContentBlock }
        ]);
    }
    create(value?: PartialMessage<Content>): Content {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.subject = "";
        message.body = "";
        message.actionUrl = "";
        message.contentBlocks = [];
        if (value !== undefined)
            reflectionMergePartial<Content>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Content): Content {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string subject */ 1:
                    message.subject = reader.string();
                    break;
                case /* string body */ 2:
                    message.body = reader.string();
                    break;
                case /* string action_url */ 3:
                    message.actionUrl = reader.string();
                    break;
                case /* repeated rd.notif.Content.ContentBlock content_blocks */ 4:
                    message.contentBlocks.push(Content_ContentBlock.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Content, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string subject = 1; */
        if (message.subject !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.subject);
        /* string body = 2; */
        if (message.body !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.body);
        /* string action_url = 3; */
        if (message.actionUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.actionUrl);
        /* repeated rd.notif.Content.ContentBlock content_blocks = 4; */
        for (let i = 0; i < message.contentBlocks.length; i++)
            Content_ContentBlock.internalBinaryWrite(message.contentBlocks[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.notif.Content
 */
export const Content = new Content$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Content_ContentBlock$Type extends MessageType<Content_ContentBlock> {
    constructor() {
        super("rd.notif.Content.ContentBlock", [
            { no: 1, name: "paragraph", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "key_values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Content_ContentBlock_KeyValue }
        ]);
    }
    create(value?: PartialMessage<Content_ContentBlock>): Content_ContentBlock {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paragraph = "";
        message.keyValues = [];
        if (value !== undefined)
            reflectionMergePartial<Content_ContentBlock>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Content_ContentBlock): Content_ContentBlock {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string paragraph */ 1:
                    message.paragraph = reader.string();
                    break;
                case /* repeated rd.notif.Content.ContentBlock.KeyValue key_values */ 2:
                    message.keyValues.push(Content_ContentBlock_KeyValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Content_ContentBlock, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string paragraph = 1; */
        if (message.paragraph !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.paragraph);
        /* repeated rd.notif.Content.ContentBlock.KeyValue key_values = 2; */
        for (let i = 0; i < message.keyValues.length; i++)
            Content_ContentBlock_KeyValue.internalBinaryWrite(message.keyValues[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.notif.Content.ContentBlock
 */
export const Content_ContentBlock = new Content_ContentBlock$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Content_ContentBlock_KeyValue$Type extends MessageType<Content_ContentBlock_KeyValue> {
    constructor() {
        super("rd.notif.Content.ContentBlock.KeyValue", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Content_ContentBlock_KeyValue>): Content_ContentBlock_KeyValue {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.key = "";
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial<Content_ContentBlock_KeyValue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Content_ContentBlock_KeyValue): Content_ContentBlock_KeyValue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string key */ 1:
                    message.key = reader.string();
                    break;
                case /* string value */ 2:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Content_ContentBlock_KeyValue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string key = 1; */
        if (message.key !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.key);
        /* string value = 2; */
        if (message.value !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.notif.Content.ContentBlock.KeyValue
 */
export const Content_ContentBlock_KeyValue = new Content_ContentBlock_KeyValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Notif$Type extends MessageType<Notif> {
    constructor() {
        super("rd.notif.Notif", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "target", kind: "message", T: () => Notif_Target },
            { no: 3, name: "event", kind: "enum", T: () => ["rd.notif.Event", Event, "EVENT_"] },
            { no: 4, name: "sender", kind: "message", T: () => User },
            { no: 5, name: "content", kind: "message", T: () => Content },
            { no: 6, name: "scheduled_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "batch_id", kind: "message", T: () => UUID },
            { no: 9, name: "company_id", kind: "message", T: () => UUID },
            { no: 10, name: "location_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<Notif>): Notif {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.event = 0;
        if (value !== undefined)
            reflectionMergePartial<Notif>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Notif): Notif {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.notif.Notif.Target target */ 2:
                    message.target = Notif_Target.internalBinaryRead(reader, reader.uint32(), options, message.target);
                    break;
                case /* rd.notif.Event event */ 3:
                    message.event = reader.int32();
                    break;
                case /* rd.user.User sender */ 4:
                    message.sender = User.internalBinaryRead(reader, reader.uint32(), options, message.sender);
                    break;
                case /* rd.notif.Content content */ 5:
                    message.content = Content.internalBinaryRead(reader, reader.uint32(), options, message.content);
                    break;
                case /* google.protobuf.Timestamp scheduled_at */ 6:
                    message.scheduledAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.scheduledAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 7:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID batch_id */ 8:
                    message.batchId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.batchId);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 9:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 10:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Notif, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.notif.Notif.Target target = 2; */
        if (message.target)
            Notif_Target.internalBinaryWrite(message.target, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.notif.Event event = 3; */
        if (message.event !== 0)
            writer.tag(3, WireType.Varint).int32(message.event);
        /* rd.user.User sender = 4; */
        if (message.sender)
            User.internalBinaryWrite(message.sender, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.notif.Content content = 5; */
        if (message.content)
            Content.internalBinaryWrite(message.content, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp scheduled_at = 6; */
        if (message.scheduledAt)
            Timestamp.internalBinaryWrite(message.scheduledAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 7; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID batch_id = 8; */
        if (message.batchId)
            UUID.internalBinaryWrite(message.batchId, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 9; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 10; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.notif.Notif
 */
export const Notif = new Notif$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Notif_Target$Type extends MessageType<Notif_Target> {
    constructor() {
        super("rd.notif.Notif.Target", [
            { no: 1, name: "type", kind: "enum", T: () => ["rd.notif.Notif.Target.Type", Notif_Target_Type, "TYPE_"] },
            { no: 2, name: "customer_id", kind: "message", T: () => UUID },
            { no: 3, name: "customer_contact_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "staff_id", kind: "message", T: () => UUID },
            { no: 5, name: "in_app_location_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<Notif_Target>): Notif_Target {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.customerContactId = "";
        if (value !== undefined)
            reflectionMergePartial<Notif_Target>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Notif_Target): Notif_Target {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.notif.Notif.Target.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 2:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* string customer_contact_id */ 3:
                    message.customerContactId = reader.string();
                    break;
                case /* rd.proto.uuid.UUID staff_id */ 4:
                    message.staffId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.staffId);
                    break;
                case /* rd.proto.uuid.UUID in_app_location_id */ 5:
                    message.inAppLocationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.inAppLocationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Notif_Target, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.notif.Notif.Target.Type type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* rd.proto.uuid.UUID customer_id = 2; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string customer_contact_id = 3; */
        if (message.customerContactId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.customerContactId);
        /* rd.proto.uuid.UUID staff_id = 4; */
        if (message.staffId)
            UUID.internalBinaryWrite(message.staffId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID in_app_location_id = 5; */
        if (message.inAppLocationId)
            UUID.internalBinaryWrite(message.inAppLocationId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.notif.Notif.Target
 */
export const Notif_Target = new Notif_Target$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Delivery$Type extends MessageType<Delivery> {
    constructor() {
        super("rd.notif.Delivery", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "recipient", kind: "enum", T: () => ["rd.notif.Delivery.Recipient", Delivery_Recipient, "RECIPIENT_"] },
            { no: 3, name: "email", kind: "message", T: () => Delivery_Email },
            { no: 4, name: "sms", kind: "message", T: () => Delivery_SMS },
            { no: 5, name: "in_app", kind: "message", T: () => Delivery_InApp },
            { no: 12, name: "sink", kind: "enum", T: () => ["rd.notif.Sink", Sink, "SINK_"] },
            { no: 13, name: "content", kind: "message", T: () => Content },
            { no: 14, name: "notified_at", kind: "message", T: () => Timestamp },
            { no: 15, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 16, name: "read_at", kind: "message", T: () => Timestamp },
            { no: 17, name: "archived_at", kind: "message", T: () => Timestamp },
            { no: 18, name: "notif_id", kind: "message", T: () => UUID },
            { no: 19, name: "company_id", kind: "message", T: () => UUID },
            { no: 20, name: "location_id", kind: "message", T: () => UUID },
            { no: 21, name: "status", kind: "enum", T: () => ["rd.notif.Delivery.Status", Delivery_Status, "STATUS_"] }
        ]);
    }
    create(value?: PartialMessage<Delivery>): Delivery {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.recipient = 0;
        message.sink = 0;
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<Delivery>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Delivery): Delivery {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.notif.Delivery.Recipient recipient */ 2:
                    message.recipient = reader.int32();
                    break;
                case /* rd.notif.Delivery.Email email */ 3:
                    message.email = Delivery_Email.internalBinaryRead(reader, reader.uint32(), options, message.email);
                    break;
                case /* rd.notif.Delivery.SMS sms */ 4:
                    message.sms = Delivery_SMS.internalBinaryRead(reader, reader.uint32(), options, message.sms);
                    break;
                case /* rd.notif.Delivery.InApp in_app */ 5:
                    message.inApp = Delivery_InApp.internalBinaryRead(reader, reader.uint32(), options, message.inApp);
                    break;
                case /* rd.notif.Sink sink */ 12:
                    message.sink = reader.int32();
                    break;
                case /* rd.notif.Content content */ 13:
                    message.content = Content.internalBinaryRead(reader, reader.uint32(), options, message.content);
                    break;
                case /* google.protobuf.Timestamp notified_at */ 14:
                    message.notifiedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.notifiedAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 15:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp read_at */ 16:
                    message.readAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.readAt);
                    break;
                case /* google.protobuf.Timestamp archived_at */ 17:
                    message.archivedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.archivedAt);
                    break;
                case /* rd.proto.uuid.UUID notif_id */ 18:
                    message.notifId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.notifId);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 19:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 20:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* rd.notif.Delivery.Status status */ 21:
                    message.status = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Delivery, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.notif.Delivery.Recipient recipient = 2; */
        if (message.recipient !== 0)
            writer.tag(2, WireType.Varint).int32(message.recipient);
        /* rd.notif.Delivery.Email email = 3; */
        if (message.email)
            Delivery_Email.internalBinaryWrite(message.email, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.notif.Delivery.SMS sms = 4; */
        if (message.sms)
            Delivery_SMS.internalBinaryWrite(message.sms, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.notif.Delivery.InApp in_app = 5; */
        if (message.inApp)
            Delivery_InApp.internalBinaryWrite(message.inApp, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.notif.Sink sink = 12; */
        if (message.sink !== 0)
            writer.tag(12, WireType.Varint).int32(message.sink);
        /* rd.notif.Content content = 13; */
        if (message.content)
            Content.internalBinaryWrite(message.content, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp notified_at = 14; */
        if (message.notifiedAt)
            Timestamp.internalBinaryWrite(message.notifiedAt, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 15; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp read_at = 16; */
        if (message.readAt)
            Timestamp.internalBinaryWrite(message.readAt, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp archived_at = 17; */
        if (message.archivedAt)
            Timestamp.internalBinaryWrite(message.archivedAt, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID notif_id = 18; */
        if (message.notifId)
            UUID.internalBinaryWrite(message.notifId, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 19; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 20; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* rd.notif.Delivery.Status status = 21; */
        if (message.status !== 0)
            writer.tag(21, WireType.Varint).int32(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.notif.Delivery
 */
export const Delivery = new Delivery$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Delivery_Email$Type extends MessageType<Delivery_Email> {
    constructor() {
        super("rd.notif.Delivery.Email", [
            { no: 1, name: "from_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "from_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "reply_to_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "logo_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "website_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "to_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "to_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "allow_inactive_company", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<Delivery_Email>): Delivery_Email {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fromEmail = "";
        message.fromName = "";
        message.replyToEmail = "";
        message.logoUrl = "";
        message.websiteUrl = "";
        message.toEmail = "";
        message.toName = "";
        message.allowInactiveCompany = false;
        if (value !== undefined)
            reflectionMergePartial<Delivery_Email>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Delivery_Email): Delivery_Email {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string from_email */ 1:
                    message.fromEmail = reader.string();
                    break;
                case /* string from_name */ 2:
                    message.fromName = reader.string();
                    break;
                case /* string reply_to_email */ 3:
                    message.replyToEmail = reader.string();
                    break;
                case /* string logo_url */ 4:
                    message.logoUrl = reader.string();
                    break;
                case /* string website_url */ 5:
                    message.websiteUrl = reader.string();
                    break;
                case /* string to_email */ 6:
                    message.toEmail = reader.string();
                    break;
                case /* string to_name */ 7:
                    message.toName = reader.string();
                    break;
                case /* bool allow_inactive_company */ 8:
                    message.allowInactiveCompany = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Delivery_Email, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string from_email = 1; */
        if (message.fromEmail !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fromEmail);
        /* string from_name = 2; */
        if (message.fromName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.fromName);
        /* string reply_to_email = 3; */
        if (message.replyToEmail !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.replyToEmail);
        /* string logo_url = 4; */
        if (message.logoUrl !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.logoUrl);
        /* string website_url = 5; */
        if (message.websiteUrl !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.websiteUrl);
        /* string to_email = 6; */
        if (message.toEmail !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.toEmail);
        /* string to_name = 7; */
        if (message.toName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.toName);
        /* bool allow_inactive_company = 8; */
        if (message.allowInactiveCompany !== false)
            writer.tag(8, WireType.Varint).bool(message.allowInactiveCompany);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.notif.Delivery.Email
 */
export const Delivery_Email = new Delivery_Email$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Delivery_SMS$Type extends MessageType<Delivery_SMS> {
    constructor() {
        super("rd.notif.Delivery.SMS", [
            { no: 1, name: "from_phone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "to_phone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Delivery_SMS>): Delivery_SMS {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fromPhone = "";
        message.toPhone = "";
        if (value !== undefined)
            reflectionMergePartial<Delivery_SMS>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Delivery_SMS): Delivery_SMS {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string from_phone */ 1:
                    message.fromPhone = reader.string();
                    break;
                case /* string to_phone */ 2:
                    message.toPhone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Delivery_SMS, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string from_phone = 1; */
        if (message.fromPhone !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.fromPhone);
        /* string to_phone = 2; */
        if (message.toPhone !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.toPhone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.notif.Delivery.SMS
 */
export const Delivery_SMS = new Delivery_SMS$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Delivery_InApp$Type extends MessageType<Delivery_InApp> {
    constructor() {
        super("rd.notif.Delivery.InApp", [
            { no: 1, name: "user_id", kind: "message", T: () => UUID },
            { no: 2, name: "location_id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<Delivery_InApp>): Delivery_InApp {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<Delivery_InApp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Delivery_InApp): Delivery_InApp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID user_id */ 1:
                    message.userId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.userId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 2:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Delivery_InApp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID user_id = 1; */
        if (message.userId)
            UUID.internalBinaryWrite(message.userId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 2; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.notif.Delivery.InApp
 */
export const Delivery_InApp = new Delivery_InApp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Preferences$Type extends MessageType<Preferences> {
    constructor() {
        super("rd.notif.Preferences", [
            { no: 1, name: "disabled_sinks", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.notif.Sink", Sink, "SINK_"] }
        ]);
    }
    create(value?: PartialMessage<Preferences>): Preferences {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.disabledSinks = [];
        if (value !== undefined)
            reflectionMergePartial<Preferences>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Preferences): Preferences {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.notif.Sink disabled_sinks */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.disabledSinks.push(reader.int32());
                    else
                        message.disabledSinks.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Preferences, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.notif.Sink disabled_sinks = 1; */
        if (message.disabledSinks.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.disabledSinks.length; i++)
                writer.int32(message.disabledSinks[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.notif.Preferences
 */
export const Preferences = new Preferences$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PreferenceUpdate$Type extends MessageType<PreferenceUpdate> {
    constructor() {
        super("rd.notif.PreferenceUpdate", [
            { no: 1, name: "event", kind: "enum", T: () => ["rd.notif.Event", Event, "EVENT_"] },
            { no: 2, name: "sink", kind: "enum", T: () => ["rd.notif.Sink", Sink, "SINK_"] },
            { no: 3, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<PreferenceUpdate>): PreferenceUpdate {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.event = 0;
        message.sink = 0;
        message.enabled = false;
        if (value !== undefined)
            reflectionMergePartial<PreferenceUpdate>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PreferenceUpdate): PreferenceUpdate {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.notif.Event event */ 1:
                    message.event = reader.int32();
                    break;
                case /* rd.notif.Sink sink */ 2:
                    message.sink = reader.int32();
                    break;
                case /* bool enabled */ 3:
                    message.enabled = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PreferenceUpdate, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.notif.Event event = 1; */
        if (message.event !== 0)
            writer.tag(1, WireType.Varint).int32(message.event);
        /* rd.notif.Sink sink = 2; */
        if (message.sink !== 0)
            writer.tag(2, WireType.Varint).int32(message.sink);
        /* bool enabled = 3; */
        if (message.enabled !== false)
            writer.tag(3, WireType.Varint).bool(message.enabled);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.notif.PreferenceUpdate
 */
export const PreferenceUpdate = new PreferenceUpdate$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StaffPreferences$Type extends MessageType<StaffPreferences> {
    constructor() {
        super("rd.notif.StaffPreferences", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "preferences", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "message", T: () => Preferences } }
        ]);
    }
    create(value?: PartialMessage<StaffPreferences>): StaffPreferences {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.preferences = {};
        if (value !== undefined)
            reflectionMergePartial<StaffPreferences>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: StaffPreferences): StaffPreferences {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* map<int32, rd.notif.Preferences> preferences */ 5:
                    this.binaryReadMap5(message.preferences, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: StaffPreferences["preferences"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof StaffPreferences["preferences"] | undefined, val: StaffPreferences["preferences"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int32();
                    break;
                case 2:
                    val = Preferences.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.notif.StaffPreferences.preferences");
            }
        }
        map[key ?? 0] = val ?? Preferences.create();
    }
    internalBinaryWrite(message: StaffPreferences, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* map<int32, rd.notif.Preferences> preferences = 5; */
        for (let k of globalThis.Object.keys(message.preferences)) {
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k));
            writer.tag(2, WireType.LengthDelimited).fork();
            Preferences.internalBinaryWrite(message.preferences[k as any], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.notif.StaffPreferences
 */
export const StaffPreferences = new StaffPreferences$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CustomerContactPreferences$Type extends MessageType<CustomerContactPreferences> {
    constructor() {
        super("rd.notif.CustomerContactPreferences", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "customer_id", kind: "message", T: () => UUID },
            { no: 5, name: "company_id", kind: "message", T: () => UUID },
            { no: 6, name: "preferences", kind: "map", K: 5 /*ScalarType.INT32*/, V: { kind: "message", T: () => Preferences } }
        ]);
    }
    create(value?: PartialMessage<CustomerContactPreferences>): CustomerContactPreferences {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.preferences = {};
        if (value !== undefined)
            reflectionMergePartial<CustomerContactPreferences>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CustomerContactPreferences): CustomerContactPreferences {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 4:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 5:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* map<int32, rd.notif.Preferences> preferences */ 6:
                    this.binaryReadMap6(message.preferences, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: CustomerContactPreferences["preferences"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof CustomerContactPreferences["preferences"] | undefined, val: CustomerContactPreferences["preferences"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.int32();
                    break;
                case 2:
                    val = Preferences.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.notif.CustomerContactPreferences.preferences");
            }
        }
        map[key ?? 0] = val ?? Preferences.create();
    }
    internalBinaryWrite(message: CustomerContactPreferences, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 4; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 5; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* map<int32, rd.notif.Preferences> preferences = 6; */
        for (let k of globalThis.Object.keys(message.preferences)) {
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.Varint).int32(parseInt(k));
            writer.tag(2, WireType.LengthDelimited).fork();
            Preferences.internalBinaryWrite(message.preferences[k as any], writer, options);
            writer.join().join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.notif.CustomerContactPreferences
 */
export const CustomerContactPreferences = new CustomerContactPreferences$Type();
